import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { IngredientProduct } from '@woolworthsnz/trader-api';
import { IngredientStampComponent } from '../ingredient-stamp/ingredient-stamp.component';
import { NgIf, NgFor } from '@angular/common';

@Component({
	selector: 'recipe-ingredient-grid',
	templateUrl: './ingredient-grid.component.html',
	styleUrls: ['./ingredient-grid.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf, NgFor, IngredientStampComponent],
})
export class IngredientGridComponent {
	@Input() ingredients?: IngredientProduct[] = [];
	@Input() selectedSkus: string[] = [];
	@Input() gridType: 'main' | 'pantry';
	@Input() title: string;

	@Output() selectionsChanged = new EventEmitter<(string | undefined)[]>();
	@Output() quantityChanged = new EventEmitter<{ sku: string | undefined; quantity: number }>();

	trackByProductSku: TrackByFunction<IngredientProduct> = (_, p: IngredientProduct) => p.item?.sku;

	selectionChange({ sku, selected }: { sku: string; selected: boolean }): void {
		const updatedList = [...this.selectedSkus];
		const index = updatedList.indexOf(sku);

		// if deselected, remove from array
		if (!selected && index > -1) {
			updatedList.splice(index, 1);
		}

		// if reselected, add to array
		if (selected && index < 0) {
			updatedList.push(sku);
		}

		this.selectionsChanged.emit(updatedList);
	}

	deselectAll(): void {
		this.selectionsChanged.emit([]);
	}

	selectAll(): void {
		const allItems = this.ingredients?.filter((i) => !!i.item?.sku).map((i) => i.item?.sku) || [];
		this.selectionsChanged.emit(allItems);
	}

	handleQuantityChanged(event: any): void {
		this.quantityChanged.emit(event);
	}
}
